import React, { useState } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import PopupContainer from "../../UI/PopupContainer";
import { InactiveIcon, ActiveIcon } from "./Icons";

const FootnoteContainer = styled.span`
  display: ${({ visible }) => (visible ? "block" : "none")};
  position: absolute;
  top: 0;
  z-index: 1;
  min-width: 200px;
  max-width: 280px;
  margin-top: 0;

  ${({ screenHalf = "left" }) =>
    screenHalf === "left"
      ? css`
          left: 0px;
        `
      : css`
          right: 0px;
        `};
`;

function findScreenHalf({ target, clientX: clickXPosition }) {
  const halfWindowWidth = window.innerWidth / 2;
  let xPosition;

  if (clickXPosition) {
    xPosition = clickXPosition;
  } else {
    const { left, width } = target.getBoundingClientRect();
    xPosition = left + width / 2;
  }

  return xPosition <= halfWindowWidth ? "left" : "right";
}

export default function Footnote({ children }) {
  const [visible, setVisibility] = useState(false);
  const [screenHalf, setScreenHalf] = useState("left");

  const showFootnote = e => {
    e.stopPropagation();
    setScreenHalf(findScreenHalf(e));
    setVisibility(true);
  };

  const hideFootnote = e => {
    e.stopPropagation();
    setVisibility(false);
  };

  const onKeyDown = e => {
    if (e.keyCode === 13) {
      if (visible) {
        e.stopPropagation();
        setVisibility(false);
      } else {
        showFootnote(e);
      }
    }
  };

  return (
    <span
      role="button"
      style={{ outline: "none", position: "relative" }}
      tabIndex={0}
      onKeyDown={onKeyDown}
      onFocus={showFootnote}
      onBlur={hideFootnote}
      onClick={showFootnote}
    >
      <InactiveIcon />
      <FootnoteContainer visible={visible} screenHalf={screenHalf}>
        <ActiveIcon onClick={hideFootnote} side={screenHalf} />
        <PopupContainer onClick={e => e.stopPropagation()}>
          {children}
        </PopupContainer>
      </FootnoteContainer>
    </span>
  );
}

Footnote.propTypes = { children: PropTypes.node.isRequired };
